<form
    #form="ngForm"
    name="form"
    [ngClass]="{'ng-submitted': form.submitted}"
    unsaved-warning-form=""
    novalidate
>
    <div class="row actions">
        <div>
            <div class="row zahlungen-form flex-row-start-center">
                <!-- Gemeinde -->
                <div
                    [ngClass]="{
                        'col-md-3': !settings().testMode,
                        'col-md-2': settings().testMode
                    }"
                >
                    <div class="form-group">
                        <label class="md-no-float" for="gemeinde" translate
                            >GEMEINDE</label
                        >
                        <div class="dv-select-style">
                            <select
                                class="form-control"
                                [(ngModel)]="model.gemeinde"
                                id="gemeinde"
                                name="gemeinde"
                                #gemeinde="ngModel"
                                required
                                data-test="gemeinde"
                            >
                                <option [ngValue]="null"></option>
                                @for (
                                    gemeindeEntry of gemeindenList();
                                    track gemeindeEntry
                                ) {
                                    <option [ngValue]="gemeindeEntry">
                                        {{ gemeindeEntry.name }}
                                    </option>
                                }
                            </select>
                            <dv-error-messages
                                [errorObject]="gemeinde.errors"
                                class="error"
                            ></dv-error-messages>
                        </div>
                    </div>
                </div>

                <div
                    [ngClass]="{
                        'col-md-3': !settings().testMode,
                        'col-md-2': settings().testMode
                    }"
                >
                    <div class="form-group">
                        <label
                            class="md-no-float"
                            for="faelligkeitsdatumPicker"
                            translate
                            >ZAHLUNG_FAELLIGKEITSDATUM</label
                        >
                        <input
                            class="dv-mat-datepicker"
                            type="text"
                            name="faelligkeitsdatumPicker"
                            id="faelligkeitsdatumPicker"
                            #faelligkeitsdatum="ngModel"
                            [(ngModel)]="model.faelligkeitsdatum"
                            [matDatepicker]="faelligkeitsdatumPicker"
                            placeholder="{{ 'DATE_PLACEHOLDER' | translate }}"
                            data-test="faelligkeitsdatum"
                            required
                        />
                        <mat-datepicker-toggle
                            matSuffix
                            [for]="faelligkeitsdatumPicker"
                        ></mat-datepicker-toggle>
                        <mat-datepicker
                            #faelligkeitsdatumPicker
                        ></mat-datepicker>
                        <dv-error-messages
                            [errorObject]="
                                faelligkeitsdatum.dirty || form.submitted
                                    ? faelligkeitsdatum.errors
                                    : null
                            "
                            class="error"
                        ></dv-error-messages>
                    </div>
                </div>
                @if (settings().testMode) {
                    <div class="col-md-2">
                        <div class="form-group">
                            <label
                                class="md-no-float"
                                for="datumGeneriertPicker"
                                translate
                                >ZAHLUNG_GENERIERT</label
                            >
                            <input
                                class="dv-mat-datepicker"
                                type="text"
                                name="datumGeneriertPicker"
                                id="datumGeneriertPicker"
                                #datumGeneriert="ngModel"
                                [(ngModel)]="model.datumGeneriert"
                                [matDatepicker]="datumGeneriertPicker"
                                placeholder="{{
                                    'DATE_PLACEHOLDER' | translate
                                }}"
                                data-test="generiertdatum"
                            />
                            <mat-datepicker-toggle
                                matSuffix
                                [for]="datumGeneriertPicker"
                            ></mat-datepicker-toggle>
                            <mat-datepicker
                                #datumGeneriertPicker
                            ></mat-datepicker>
                            <dv-error-messages
                                [errorObject]="datumGeneriert.errors"
                                class="error"
                            ></dv-error-messages>
                        </div>
                    </div>
                }
                <div
                    [ngClass]="{
                        'col-md-4': !settings().testMode,
                        'col-md-3': settings().testMode
                    }"
                >
                    <div class="form-group">
                        <label class="md-no-float" translate for="beschrieb"
                            >ZAHLUNG_BESCHRIEB</label
                        >
                        <input
                            id="beschrieb"
                            name="beschrieb"
                            #beschrieb="ngModel"
                            [(ngModel)]="model.beschrieb"
                            class="form-control input-dv input-element"
                            required
                            data-test="beschrieb"
                        />
                        <dv-error-messages
                            [errorObject]="beschrieb.errors"
                            class="error"
                        ></dv-error-messages>
                    </div>
                </div>
                @if (settings().checkboxAuszahlungInZukunft) {
                    <div class="full-width-row">
                        <dv-checkbox-x
                            [label]="'CHECKBOX_AUSZAHLUNG_IN_ZUKUNFT'"
                            [(model)]="model.auszahlungInZukunft"
                            [displayBisher]="false"
                        ></dv-checkbox-x>
                    </div>
                }
                <div flex layout="row" layout-align="center center">
                    <dv-loading-button
                        (buttonClick)="createZahlungsauftrag()"
                        [ariaLabel]="getLabelZahlungslaufErstellen()"
                        type="submit"
                        data-test="container.senden"
                    >
                        <span class="uppercase">{{
                            getLabelZahlungslaufErstellen()
                        }}</span>
                    </dv-loading-button>
                </div>
            </div>
        </div>
    </div>
</form>
